
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignExit as ObiSignExitElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-exit.js';
 
 
 

 
 export const ObiSignExit = createComponent({
   react: React,
   tagName: 'obi-sign-exit',
   elementClass: ObiSignExitElement,
   events: {
     
   }
  });
 
 